import { Col, Row } from "antd";
import {
  faArrowRightArrowLeft,
  faBolt,
  faGlobe,
  faHeadset,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, FC } from "react";
import { useTranslation } from "react-i18next";

/** Same layout/markup as `VisaHeroHighlights` — icon badge + bold title + small desc, connected by arrows. */
const EsimHubHighlights: FC = () => {
  const { t } = useTranslation();

  const items = [
    {
      icon: faGlobe,
      title: t("esim.hub_highlight_title_multi_country"),
      desc: t("esim.hub_highlight_desc_multi_country"),
    },
    {
      icon: faStar,
      title: t("esim.hub_highlight_title_network"),
      desc: t("esim.hub_highlight_desc_network"),
    },
    {
      icon: faHeadset,
      title: t("esim.hub_highlight_title_support"),
      desc: t("esim.hub_highlight_desc_support"),
    },
    {
      icon: faBolt,
      title: t("esim.hub_highlight_title_easy"),
      desc: t("esim.hub_highlight_desc_easy"),
    },
  ] as const;

  return (
    <Row wrap={false} align="middle" className="esim-hub__highlights">
      {items.map((item, index) => (
        <Fragment key={item.title}>
          <Col flex="1 1 0" className="esim-hub__highlight-col">
            <div className="esim-hub__highlight-item">
              <span className="esim-hub__highlight-icon">
                <FontAwesomeIcon icon={item.icon} />
              </span>
              <div>
                <strong>{item.title}</strong>
                <p>{item.desc}</p>
              </div>
            </div>
          </Col>
          {index < items.length - 1 && (
            <Col flex="0 0 auto" className="esim-hub__highlight-arrow">
              <FontAwesomeIcon icon={faArrowRightArrowLeft} />
            </Col>
          )}
        </Fragment>
      ))}
    </Row>
  );
};

export default EsimHubHighlights;
